import { useContext } from 'react';

import { CartContext } from '../context/CartContext';

import getImgUrl from '../helper/getImgUrl';
import styles from '../styles/cart.module.css'
import CurrencyDisplay from "../components/CurrencyDisplay"

import { IoMdClose } from "react-icons/io";

const Cart = ({ viewCart, setViewCart }) => {
    const { cartItem, cartTotal, checkoutUrl, removeFromCart } = useContext(CartContext);

    const handleDeleteItemCart = async (lineId) => {
        try {
            await removeFromCart(lineId);
        } catch (error) {
            console.error('Error deleting cart item', error);
        }
    };

    const handleCheckout = () => {
        setViewCart(false);
        if (checkoutUrl) window.location.href = checkoutUrl;
    };

    return (
        <div className={viewCart ? styles.cart : styles.cartHidden}>
            <div className={styles.cartHeader}>
                <div className={styles.cartTile}>
                    <p className={styles.description}>Your cart</p>
                    <p>Cart : {cartItem.length}</p>
                </div>
                <div className={styles.closeCart}>
                    <IoMdClose onClick={() => setViewCart(false)}/>
                </div>
            </div>
            <div className={styles.cartItems}>
                {cartItem && cartItem.length > 0 ? (
                    <div className={styles.cartNotEmpty}>
                        {Array.isArray(cartItem) && cartItem.map(item => (
                            <div className={styles.itemcontainer} key={item.cart_item_id}>
                                <div className={styles.maininfo}>
                                    <div className={styles.imgcontainer}>
                                        <img src={getImgUrl(item.images?.[0], 'product')} alt=''/>
                                    </div>
                                    <div className={styles.cartinfo}>
                                        <p>{item.title}</p>
                                        <p>{item.material}</p>
                                        <div className={styles.quantitybtn}>
                                            <p>- {item.quantity} +</p>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.rightinfo}>
                                    <CurrencyDisplay amount={item.price} currency='CAD' />
                                    <IoMdClose className={styles.deletebtn} onClick={() => handleDeleteItemCart(item.cart_item_id)}/>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={styles.emptyCart}>
                        <div>
                            <p>Your cart is empty</p>
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.footerCheckout}>
                <button
                    className={cartItem && cartItem.length === 0 ? styles.checkoutDisabled : styles.checkout}
                    onClick={handleCheckout}>
                    Check out - {<CurrencyDisplay amount={cartTotal} currency='CAD' />}
                </button>
                <p>Shipping & taxes are calculated at checkout</p>
            </div>
        </div>
    )
};

export default Cart;
